import { type KolMetricPerformanceSummary } from '@/types/schema/kol-schema'

export const mockSummary: KolMetricPerformanceSummary = {
  summary:
    '該網紅的互動率和漲粉率都不錯，唯獨觀看率比較普通，為同等級的網紅的中低等級，效果不一定會好，但仍然建議可以發包開箱類型的案型，應該會比較有成效！',
}
